import React from 'react';
import './ResultCards.css';
import ResultCard from './ResulCard/ResultCard';
export default function ResultCards({results}) {
    return <div className='ResultCards'>{results
        .map((result) => <ResultCard key={result.id} result={result}></ResultCard>)}</div>
}